import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import successIcon from "../assets/alert-success.svg";
import { useNavigate } from 'react-router-dom';

export default function ThankyouModal({ show, onHide }) {

  const navigate = useNavigate()

  const [isTeacherFormSubmitted, setIsTeacherFormSubmitted] = useState(false)

  useEffect(() => {
   const urlParams = new URLSearchParams(window.location.search);
   const teacherFormParam = urlParams.get('teacherForm');
    setIsTeacherFormSubmitted(teacherFormParam === "true");
  }, [])

  return (
    <>
      <Modal show={show}>
        <Modal.Header style={{ margin: "0 auto", borderBottom: "0 none" }}>
          <div>
            <img style={{
              height: 70,
              width: 70
            }} src={successIcon} alt="icon" />
          </div>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center" }}>
          {isTeacherFormSubmitted ? (<h5>Thank you for volunteering to be a LTE teacher and nominating a student for this programme. We will get back to you shortly</h5>
          ) : (<h5>Thank you for registering a student. We will get back to you shortly.</h5>)}
          <br />
          <h5>Do you want to register another student?</h5>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "0 none", margin: "0 auto" }}>
          <Button variant="primary" style={{ minWidth: 220, borderRadius: 15 }} onClick={() => window.location.reload()}>
            Yes
          </Button>
          <Button variant="warning" style={{ minWidth: 220, borderRadius: 15 }} onClick={() => {
    onHide(); // Call onHide function
    navigate('/end'); // Call navigate function
  }}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}